import {Component, Input, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SistemaService} from '@servicios/Sistema.Service';
import {TranslateService} from '@ngx-translate/core';

declare var $: any;
declare function Focus(id: string): any;

const noop = () => {
};

export const CUSTOM_DATEPICKER_CONTROL_VALUE_ACCESSOR: any =
{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatePickerV2Component),
    multi: true
};


@Component(
    {
        selector: 'datePickerV2Custom',
        templateUrl: './DatePickerV2.template.html',
        providers: [CUSTOM_DATEPICKER_CONTROL_VALUE_ACCESSOR]
    })

export class DatePickerV2Component implements ControlValueAccessor {
    public innerValue: any = "";

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    public touched: any = "";

    @Input() titulo: string = ""; // titulo del input
    @Input() rangoFecha: boolean = false; // indica si es un rango de fechas
    @Input() mensajeError: string = ""; // indica si es un rango de fechas
    @Input() configuracion: any = null; // configuración del control de fechas
    @Input() addConfiguracion: any = null; // agrega configuracion extra del control de fechas

    @Input() disabled: boolean = false; // control deshabilitado
    @Input() verError: boolean = true; // indica si el error esta habilitado para mostrarse
    @Input() errorActivo: boolean = false; // indica si el error esta habilitado para mostrarse

    public id: number = 0;

    public fecha: any;

    constructor(public sistemaService: SistemaService, public translate: TranslateService) {
        this.mensajeError = this.translate.instant("DatoIncompeto");
        this.sistemaService.numeroControl++;
        this.id = this.sistemaService.numeroControl;
    }

    ngOnInit() {
        if (this.addConfiguracion) {
            let config = {dateFormat: this.translate.instant("FormatoFechaCalendario"), showTodayBtn: false, firstDayOfWeek: 'su', openSelectorOnInputClick: true, dateRange: this.rangoFecha, focusInputOnDateSelect: false}
            this.configuracion = {...config, ...this.addConfiguracion};
        }
    }

    ngAfterViewInit() {
    }

    Focus() {
    }

    LimpiarValor() {
        this.fecha = null;
        this.NuevaFecha();
    }

    NuevaFecha() {
        if (this.rangoFecha) {
            if (!this.fecha) {
                this.valor = null;
            }
            else {
                let nuevoValor: any = {};

                nuevoValor.Inicio = this.sistemaService.Date2StringRange(this.fecha?.dateRange?.beginDate);
                nuevoValor.Fin = this.sistemaService.Date2StringRange(this.fecha?.dateRange?.endDate);

                this.valor = nuevoValor;
            }
        }
        else {
            this.valor = this.sistemaService.Date2String(this.fecha?.singleDate);
        }
    }

    SetValorFecha() {
        if (this.rangoFecha) {
            this.SetRangoFecha(this.valor?.Inicio, this.valor?.Fin);
        }
        else {
            this.SetFecha(this.valor);
        }
    }

    SetFecha(fecha: any) {
        if (!fecha) {
            this.fecha = null;
        }
        else {
            this.fecha =
            {
                singleDate: this.sistemaService.String2DatePicker(fecha)
            };
        }
    }

    SetRangoFecha(fechaInicio: any, fechaFin: any) {
        if (!fechaInicio || !fechaFin) {
            this.fecha = null;
        }
        else {
            this.fecha =
            {
                dateRange:
                {
                    beginDate: this.sistemaService.String2DateRange(fechaInicio),
                    endDate: this.sistemaService.String2DateRange(fechaFin),
                },
                isRange: true
            };
        }
    }

    // control ngModel
    get valor(): any {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set valor(nuevoValor: any) {
        if (nuevoValor !== this.innerValue) {
            this.innerValue = nuevoValor;
            this.SetValorFecha();
            this.onChangeCallback(nuevoValor);
        }else{
            this.onChangeCallback(null);
        }
    }

    writeValue(valor: any) {
        if (valor !== this.innerValue) {
            this.innerValue = valor;
            this.SetValorFecha();
        }
    }

    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    Validar(valor: string) {
        if (valor && valor.trim()) {
            if (this.fecha == null) {
                this.onChangeCallback(valor);
            }
        }
    }
}
